// src/pages/Sso/index.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useClient } from '../../contexts/ClientContext';

// Same landing page as the normal login (see pages/Login)
const DEFAULT_ROUTE = '/clientdata';

// Entry point used by SedLex: /sso#token=...&refreshToken=...&cliente=00234&processo=00234.0006
const Sso = () => {
  const { loading, loginWithSession } = useAuth();
  const { setCliente, clearCliente } = useClient();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Wait for the AuthProvider initial validation: only then axios has its baseURL
    if (loading || started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    // Remove the session from the address bar and history right away
    window.history.replaceState(null, '', window.location.pathname);

    const run = async () => {
      const token = params.get('token');
      if (!token) {
        setError('Ligação inválida. Reabra o JRRobot a partir do SedLex.');
        return;
      }

      const result = await loginWithSession({
        token,
        refreshToken: params.get('refreshToken')
      });
      if (!result.success) {
        setError(`${result.message}. Reabra o JRRobot a partir do SedLex.`);
        return;
      }

      // SedLex is the source of truth for the context: no client means no client
      const cliente = params.get('cliente');
      if (cliente) {
        await setCliente(cliente);
      } else {
        clearCliente();
      }

      // Kept for the pages that will use it; nothing reads it yet
      const processo = params.get('processo');
      if (processo) {
        localStorage.setItem('processoSession', processo);
      } else {
        localStorage.removeItem('processoSession');
      }

      navigate(DEFAULT_ROUTE, { replace: true });
    };

    run();
  }, [loading, loginWithSession, setCliente, clearCliente, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg,rgb(82, 111, 240) 0%, #764ba2 100%)',
      padding: '1rem'
    }}>
      <div style={{
        background: 'white',
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center',
        color: error ? '#c33' : '#2c3e50'
      }}>
        {error || 'A iniciar sessão...'}
      </div>
    </div>
  );
};

export default Sso;
